// LoginTestPage.ts

export interface QuizOption {
  label: string; // e.g., "A", "B", "C"
  text: string;
  correct: boolean;
}

export interface QuizQuestion {
  id: string;
  category: string;
  question: string;
  options: QuizOption[];
}

export const AML_KYC_QUIZ_DATA: Record<string, QuizQuestion> = {
  q1: {
    id: "q1",
    category: "AML / KYC • PEPs",
    question: "What does 'PEP' stand for in AML compliance regulations?",
    options: [
      { label: "A", text: "Politically Exposed Person", correct: true },
      { label: "B", text: "Publicly Eligible Person", correct: false },
      { label: "C", text: "Privately Exempt Party", correct: false },
    ],
  },
  q2: {
    id: "q2",
    category: "AML / KYC • Reporting",
    question: "What is the primary objective of filing a Suspicious Activity Report (SAR)?",
    options: [
      { label: "A", text: "To notify customers before freezing funds", correct: false },
      { label: "B", text: "To report potential illegal financial activity to authorities", correct: true },
      { label: "C", text: "To request approval for foreign transfers", correct: false },
    ],
  },
  q3: {
    id: "q3",
    category: "AML / KYC • Typologies",
    question: "Which stage of money laundering involves placing illicit cash into the financial system?",
    options: [
      { label: "A", text: "Placement", correct: true },
      { label: "B", text: "Layering", correct: false },
      { label: "C", text: "Integration", correct: false },
    ],
  },
  q4: {
    id: "q4",
    category: "AML / KYC • Typologies",
    question: "What does the term 'Structuring' or 'Smurfing' refer to?",
    options: [
      { label: "A", text: "Concealing ownership in offshore corporations", correct: false },
      { label: "B", text: "Breaking cash deposits into smaller amounts to evade thresholds", correct: true },
      { label: "C", text: "Manipulating currency exchange rates", correct: false },
    ],
  },
  q5: {
    id: "q5",
    category: "AML / KYC • Due Diligence",
    question: "Under FATF standards, what does 'EDD' stand for?",
    options: [
      { label: "A", text: "Extended Document Verification", correct: false },
      { label: "B", text: "Enhanced Due Diligence", correct: true },
      { label: "C", text: "Electronic Disclosure Diagnostics", correct: false },
    ],
  },
  q6: {
    id: "q6",
    category: "AML / KYC • Risk Assessment",
    question: "When is Enhanced Due Diligence (EDD) mandatory for a institution?",
    options: [
      { label: "A", text: "When dealing with High-Risk Customers or PEPs", correct: true },
      { label: "B", text: "For all retail savings accounts opening", correct: false },
      { label: "C", text: "Only when instructed by court order", correct: false },
    ],
  },
  q7: {
    id: "q7",
    category: "AML / KYC • Typologies",
    question: "What is the primary purpose of the 'Layering' stage in money laundering?",
    options: [
      { label: "A", text: "To introduce physical cash into a regulated bank", correct: false },
      { label: "B", text: "To distance illicit funds from source using complex transactions", correct: true },
      { label: "C", text: "To buy high-value real estate in cash", correct: false },
    ],
  },
  q8: {
    id: "q8",
    category: "AML / KYC • Corporate Structures",
    question: "What is an Ultimate Beneficial Owner (UBO)?",
    options: [
      { label: "A", text: "The natural person who ultimately owns or controls a entity", correct: true },
      { label: "B", text: "The appointed external audit representative", correct: false },
      { label: "C", text: "The highest paid executive officer of a business", correct: false },
    ],
  },
  q9: {
    id: "q9",
    category: "AML / KYC • Due Diligence",
    question: "What ownership threshold percentage is most commonly used to identify a UBO?",
    options: [
      { label: "A", text: "10% or more", correct: false },
      { label: "B", text: "25% or more", correct: true },
      { label: "C", text: "50% or more", correct: false },
    ],
  },
  q10: {
    id: "q10",
    category: "AML / KYC • Governance",
    question: "What is the global intergovernmental body that sets international AML standards?",
    options: [
      { label: "A", text: "FATF (Financial Action Task Force)", correct: true },
      { label: "B", text: "OFAC (Office of Foreign Assets Control)", correct: false },
      { label: "C", text: "FINRA (Financial Industry Regulatory Authority)", correct: false },
    ],
  },
  q11: {
    id: "q11",
    category: "AML / KYC • High-Risk Entities",
    question: "What defines a 'Shell Bank'?",
    options: [
      { label: "A", text: "A online bank operating without physical presence in any jurisdiction", correct: true },
      { label: "B", text: "A bank branch located in an international airport", correct: false },
      { label: "C", text: "A regional credit union serving coastal areas", correct: false },
    ],
  },
  q12: {
    id: "q12",
    category: "AML / KYC • Compliance Offenses",
    question: "What constitutes the offense of 'Tipping Off' in financial compliance?",
    options: [
      { label: "A", text: "Inform a client that a SAR/STR has been filed regarding them", correct: true },
      { label: "B", text: "Alerting internal management to operational issues", correct: false },
      { label: "C", text: "Sharing market information with news outlets", correct: false },
    ],
  },
  q13: {
    id: "q13",
    category: "AML / KYC • Wire Transfers",
    question: "What does the FATF 'Travel Rule' require financial institutions to do?",
    options: [
      { label: "A", text: "Pass originator and beneficiary details alongside wire transfers", correct: true },
      { label: "B", text: "Track international physical travel of high-net-worth clients", correct: false },
      { label: "C", text: "Impose automatic 24-hour holds on international transfers", correct: false },
    ],
  },
  q14: {
    id: "q14",
    category: "AML / KYC • Due Diligence",
    question: "What is Customer Due Diligence (CDD)?",
    options: [
      { label: "A", text: "Verifying identity and assessing risks before establishing a relationship", correct: true },
      { label: "B", text: "Auditing employee internal transactions", correct: false },
      { label: "C", text: "Evaluating credit ratings for personal loans", correct: false },
    ],
  },
  q15: {
    id: "q15",
    category: "AML / KYC • Trade-Based ML",
    question: "Which mechanism is commonly associated with Trade-Based Money Laundering (TBML)?",
    options: [
      { label: "A", text: "Over-invoicing or under-invoicing goods and services", correct: true },
      { label: "B", text: "Purchasing low-risk government bonds", correct: false },
      { label: "C", text: "Settling credit card transactions electronically", correct: false },
    ],
  },
  q16: {
    id: "q16",
    category: "AML / KYC • Sanctions",
    question: "What is the primary function of Sanctions Screening?",
    options: [
      { label: "A", text: "Ensuring entities are checked against prohibited government lists", correct: true },
      { label: "B", text: "Calculating foreign exchange conversion fees", correct: false },
      { label: "C", text: "Assessing customer debt-to-income ratios", correct: false },
    ],
  },
  q17: {
    id: "q17",
    category: "AML / KYC • Monitoring",
    question: "What does 'Ongoing Monitoring' entail in a KYC context?",
    options: [
      { label: "A", text: "Continuous review of transactions and customer risk profiles", correct: true },
      { label: "B", text: "A single verification check at account creation", correct: false },
      { label: "C", text: "Checking customer details strictly every five years", correct: false },
    ],
  },
  q18: {
    id: "q18",
    category: "AML / KYC • Banking Relationships",
    question: "What is a 'Nested' correspondent banking relationship?",
    options: [
      { label: "A", text: "When a foreign bank accesses correspondent services via a respondent bank", correct: true },
      { label: "B", text: "When a customer holds multiple joint savings accounts", correct: false },
      { label: "C", text: "When branches share identical IT infrastructure", correct: false },
    ],
  },
  q19: {
    id: "q19",
    category: "AML / KYC • Regulatory Bodies",
    question: "What does OFAC stand for?",
    options: [
      { label: "A", text: "Office of Foreign Assets Control", correct: true },
      { label: "B", text: "Organization for Financial Analysis & Control", correct: false },
      { label: "C", text: "Overseas Financial Anti-Crime Bureau", correct: false },
    ],
  },
  q20: {
    id: "q20",
    category: "AML / KYC • Typologies",
    question: "What occurs during the 'Integration' phase of money laundering?",
    options: [
      { label: "A", text: "Laundered funds re-enter the legitimate economy via investments", correct: true },
      { label: "B", text: "Illicit cash is divided into multiple small deposits", correct: false },
      { label: "C", text: "Funds are wired across multiple offshore accounts", correct: false },
    ],
  },
};
